import { z } from 'zod';
/**
 * 规格书（Spec doc）：平台级按物料（料号）归档的文件，跨产品共享，多次上传形成「更新时间线」。
 * 任一产品的 BOM 含该料号，该产品成员即可见（服务端按 BOM 料号集合过滤）。
 * 不发通知邮件；原文件存 S3，可下载。
 */
/**
 * 上传规格书（前端已 presign 上传 S3 后提交；归属料号必须全部在本产品 BOM 中，服务端校验）。
 * 可选多个料号共用同一份文件：每个料号下各写一条记录，共用同一 id 与 S3 文件。
 */
export const CreateSpecDocSchema = z.object({
    part_nos: z.array(z.string().trim().min(1).max(120)).min(1).max(100), // 归属物料料号（可多个）
    filename: z.string().trim().min(1).max(300),
    s3_key: z.string().max(500), // 原始文件 S3 key
    note: z.string().trim().max(500).optional(), // 版本说明/备注
    size_bytes: z.number().int().nonnegative().optional(),
});
//# sourceMappingURL=spec.js.map